// extracted by mini-css-extract-plugin
export var icon14 = "Icon-module--icon14--4ba7a";
export var icon20 = "Icon-module--icon20--560a0";
export var icon24 = "Icon-module--icon24--b74c8";
export var icon56 = "Icon-module--icon56--431ff";